import { render, staticRenderFns } from "./TransferAudienceTab.vue?vue&type=template&id=bdd2e46a"
import script from "./TransferAudienceTab.vue?vue&type=script&lang=js"
export * from "./TransferAudienceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports